import React, { FC } from 'react';
import { createGlobalStyle } from 'styled-components';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

const GlobalStyle = createGlobalStyle<{ fullscreen: boolean }>`
  html {
    font-size: 62.5%;
  }
  html,
  body,
  #root {
    height: 100%;
    overflow: hidden;
  }

  .fr-toolbar.fr-toolbar-open {
    padding-bottom: 0 !important;
  }

  .fr-more-toolbar {
    float: none !important;
  }

  @media screen and (max-width: 600px) {
    #_hj_feedback_container > div:first-of-type {
      bottom: 5rem;
    }
  }

  @media print {
    @page {
      size: auto;
      margin: 15mm 10mm;
    }

    html,
    body,
    #root {
      height: auto !important;
      overflow: visible !important;
      -webkit-print-color-adjust: exact !important;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    table,
    blockquote,
    pre {
      position: relative;
      display: block;
      page-break-inside: avoid;
    }

    #private_page_scroll_container {
      width: 100%;
      height: auto;
      max-width: none;
      overflow: hidden;
    }

    #private_page_external_wrapper {
      width: 100%;
      height: auto;
      max-width: none;
      overflow: hidden;
    }

    #private_page_wrapper {
      max-width: none;
      min-height: 100%;
    }

    .hide-on-print,
    #_hj_feedback_container,
    .MuiTooltip-popper,
    .fr-video {
      display: none !important;
    }
  }

  ._hj_feedback_container {
    display: ${(props) => props.fullscreen && 'none'};
  }
`;

export const FullscreenModeShell: FC = ({ children }) => {
  const showPresentationMode = useAppSelector(
    (state) => state.presentationMode.showPresentationMode
  );

  return (
    <>
      <GlobalStyle fullscreen={showPresentationMode} />
      {children}
    </>
  );
};
